import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/_work/eco.store.ecommerce-backoffice/eco.store.ecommerce-backoffice/layouts/default.vue").then(m => m.default || m))
}